import { IFileInfo } from 'react-csv-reader';
export const ASSETS_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_ASSETS_URL_DEV : process.env.REACT_APP_ASSETS_URL_PROD;

export const getArrayOfFsn = (csvData: any[]) => {
    const arrayOfFsn: any[] = [];
    csvData.forEach((it) => {
        if (it[0] && it[0].trim()) {
            arrayOfFsn.push(it[0].trim());
        }
    });
    return arrayOfFsn;
};

export const validateCSV = (csvData: any[], fileInfo: IFileInfo) => {
    if (fileInfo.type !== 'text/csv' || fileInfo.name.split('.')[1] !== 'csv') {
        return { valid: false, error: 'Not a valid CSV file' };
    }
    return isAlphaNumeric(csvData);
};

const isAlphaNumeric = (csvData: any[]) => {
    for (const fsn of csvData) {
        if (fsn.length !== 1) {
            return { valid: false, error: 'CSV contains more than 1 column' };
        } else {
            if (fsn[0].trim()?.length === 0) {
                continue;
            } else if (fsn[0].match(/^([0-9]|[A-Z])+([0-9A-Z]+)$/)) {
                continue;
            } else {
                return { valid: false, error: 'Some FSNs are wrong, please check' };
            }
        }
    }
    return { valid: true };
    // return true;
};

export const generateRandomString = () => {
    let result: string = '';
    const characters: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < characters.length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};

export const getDateAndTime = (date: string | Date | null) => {
    const d = new Date(date || '');
    if (date) {
        return d.toLocaleString('en-GB', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    }
};

export const getTime = (date?: string | Date | null) => {
    const d = new Date(date || '');
    if (date) {
        return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    }
};

export const getDate = (date?: string | Date | null) => {
    const d = new Date(date || '');
    if (date) {
        return d.toLocaleString('en-GB', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
    }
};

export const getTimeDiff = (date1: string | Date | null | undefined, date2: string | Date | null) => {
    const createdAt = new Date(date1 || '');
    const timeNow = new Date(date2 || '');
    //  @ts-ignore
    return Math.abs(createdAt - timeNow) / 36e5;
};

export const getFileNameFromUrl = (url: string) => {
    const stringArray = url.split('/');
    return stringArray[stringArray.length - 1];
};

export const elipsedText = (text: string, maxTextSize: number = 30, startingLetters: number = 20, endingLetters: number = 10) => {
    if (text.length > maxTextSize) {
        // return text.substr(0, 20) + '...' + text.substr(text.length - 10, text.length);
        return `${text.substr(0, startingLetters)}...${text.substr(text.length - endingLetters, text.length)}`;
    }
    return text;
};

export const downloadModelUrl = (url: string) => {
    window.open(url, '_blank');
};

export const calculateTriggerPipelinePercentage = (triggerPipelineResponseLength: number, modelUploadApiResponse: any[]) => {
    let failedFsns = modelUploadApiResponse.filter((item) => item.status === 'FAILED');

    let currentlen = failedFsns.length * 4 + triggerPipelineResponseLength;
    let totallen = modelUploadApiResponse.length * 4;

    //TODO: just for testing . will remove after test
    // console.log('failedFsns', failedFsns);
    // console.log('currentlen totallen', currentlen, totallen);

    const percentage = (currentlen / totallen) * 100;
    return Math.floor(percentage);
};
